import { MasterOfActsAPI } from "../api/api";
import { DynamicFields } from "./dynamicFields"
import DateTime from "luxon/src/datetime";

export const StackField = () => {
    return {
        [DynamicFields.DATE_TIME_SELECT]: [],
        [DynamicFields.SELECTED_OFFENSE_LIST]: [], //
        [DynamicFields.CHECK_LIST]: [], //
        [DynamicFields.SIGNATURE_FIELD]: [],
        [DynamicFields.TABLE_CONSTRUCTOR]: [],
        [DynamicFields.TEXT_FIELD]: [],
        [DynamicFields.MULTILINE_TEXT_FIELD]: [],
        [DynamicFields.FULL_NAME_FIELD]: [],
        [DynamicFields.NUMBER_FIELD]: [],
        [DynamicFields.NORMATIVE_ARTICLES_TABLE]: [],
        [DynamicFields.CONTRACTOR_VIOLATIONS_TABLE]: [],
        [DynamicFields.NORMATIVE_ARTICLE_SELECT]: [],
        [DynamicFields.REMOVAL_DATE_TIME]: [],
        [DynamicFields.DRAG_AND_DROP_FILES_UPLOAD]: [],
        [DynamicFields.DRAG_AND_DROP_ACT_UPLOAD]: [],
        [DynamicFields.UPLOAD_ANALYSIS]: [],
        [DynamicFields.AUTOCOMPLETE_SELECT]: [],
        [DynamicFields.FREE_AUTOCOMPLETE_SELECT]: [],
        [DynamicFields.BASE_SELECT]: [],
        [DynamicFields.CHIP_BLOCK]: [],
        [DynamicFields.CHECKBOX_FIELD]: [],
        [DynamicFields.QR_CODE_FIELD]: [],
        [DynamicFields.QR_CODE_VIOLATION]: [],
        [DynamicFields.SIGNATURE_FOR_TABLE]: [],
        [DynamicFields.CHART_CONSTRUCTOR]: [],
    }
}


export const StackCheackFieldTemplate = (stack, fieldsTemplates) => {

    let mutateStack = {...stack}

    fieldsTemplates.map((field) => {
        mutateStack[field.type].push(field.variable)
        if (field.type === DynamicFields.TABLE_CONSTRUCTOR) {
            let column = field.content.offenseWindow
            for(let el of column) {
                if (el.type === DynamicFields.SIGNATURE_FOR_TABLE) {
                    mutateStack[el.type].push(el.variable)
                }
            }
        }
    })

    return mutateStack

}


export const makeActRaw =  (stack, raw, violations) => {

    let oldRawContent = {...raw.raw_content}
    let newRawContent = {};
    let signForTable = stack[DynamicFields.SIGNATURE_FOR_TABLE]

    for (const key in stack) {

        if (key === DynamicFields.DATE_TIME_SELECT) {
            if (stack[key].length !== 0) {
                // eslint-disable-next-line no-loop-func
                stack[key].map((element) => {
                    newRawContent = {...newRawContent, ...{[element]: DateTime.now()}} 
                })
            }
        } 
            else 

        if (key === DynamicFields.SELECTED_OFFENSE_LIST) {
            if (stack[key].length !== 0) {
                // eslint-disable-next-line no-loop-func
                stack[key].map((element) => {
                    let newRawViolations = []
                    violations.map((violation, index) => {
                        let newElement = {
                            id: violation.id,
                            qrCodeViolation: '',
                        }
                        for (const key in violation.content) {
                            newElement = {...newElement, [key]: oldRawContent[element][index][key] !== undefined ? oldRawContent[element][index][key] : ''}
                        }
                        newRawViolations.push(newElement)
                    })
    
                    newRawContent = {...newRawContent, ...{[element]: oldRawContent[element] !== undefined ?  newRawViolations : ''}}
                })
            }
        }
            else

        if (key === DynamicFields.SIGNATURE_FIELD) {
            if (stack[key].length !== 0) {
                // eslint-disable-next-line no-loop-func
                stack[key].map((element) => {
                    newRawContent = {...newRawContent, ...{[element]: ''}} 
                })
            }
        }   
        
            else 

        if (key === DynamicFields.BASE_SELECT) {
                if (stack[key].length !== 0) {
                    // eslint-disable-next-line no-loop-func
                    stack[key].map((element) => {
                        newRawContent = {...newRawContent, ...{[element]: oldRawContent[element] !== undefined ?  oldRawContent[element] : ''}} 
                    })
                }
        }   
            
            else 

        if (key === DynamicFields.TABLE_CONSTRUCTOR) {
                if (stack[key].length !== 0) {
                    // eslint-disable-next-line no-loop-func
                    stack[key].map((element) => {
                        let count = 0                    
                        for(let row of oldRawContent[element]?.data) {
                            for (let elKey in row) {
                                if(signForTable.includes(elKey)) {
                                    oldRawContent[element].data[count][elKey] = null
                                }
                            }
                            count++
                        }
                        newRawContent = {...newRawContent, ...{[element]: oldRawContent[element] !== undefined ?  oldRawContent[element] : ''}} 
                    })
                }
        } 
            else
        {
            if (stack[key].length !== 0 && key !== DynamicFields.SIGNATURE_FOR_TABLE) {
                // eslint-disable-next-line no-loop-func
                stack[key].map((element) => {
                    newRawContent = {...newRawContent, ...{[element]: oldRawContent[element] !== undefined ?  oldRawContent[element] : ''}}
                })
            }
        }      
    }
    
    return newRawContent
}


export const stackFromUpload = () => {
    return {
        [DynamicFields.SIGNATURE_FOR_TABLE]: [],
        [DynamicFields.DATE_TIME_SELECT]: [], 
        [DynamicFields.BASE_SELECT]: [],
        [DynamicFields.TABLE_DATE]: [],
        [DynamicFields.TABLE_DATE_TIME]: [],
        [DynamicFields.TABLE_TIME]: [],
    }
}

export const mutateStackUpload = (offenseList, stack) => {
    let newStack = {...stack}
    offenseList.map((column, index) => {
        if (column.type === DynamicFields.SIGNATURE_FOR_TABLE || 
            column.type === DynamicFields.DATE_TIME_SELECT || 
            column.type === DynamicFields.BASE_SELECT ||
            column.type === DynamicFields.TABLE_DATE ||
            column.type === DynamicFields.TABLE_DATE_TIME ||
            column.type === DynamicFields.TABLE_TIME 
            ) {
                newStack[column.type].push(index)
        } 
    })
    return newStack
}